import { DateObject } from 'react-multi-date-picker';

export const formatTime = (time: string): string => {
  const paddedTime = time.padStart(4, '0');
  const hour = paddedTime.slice(0, 2);
  const minute = paddedTime.slice(2);

  try {
    const formatted = new DateObject({
      year: 2025,
      month: 1,
      day: 1,
      hour: Number(hour),
      minute: Number(minute),
    }).format('hh:mm A');
    return formatted;
  } catch (error) {
    console.error('Error formatting time:', error);
    return 'Invalid Time';
  }
};
